import React from 'react'
import { AppLayout } from '../../layouts/AppLayout'
import { PageHeader } from '../../layouts/PageHeader'
import { Alert } from '../../common/Alert'
import { Button } from '../../common/Button'
import { PROJECT_ANALYSIS_PAGE_TITLE } from './constants'

export interface ProjectOverviewErrorProps {
  message: string
  onRetry: () => void
}

export function ProjectOverviewError({
  message,
  onRetry,
}: ProjectOverviewErrorProps) {
  return (
    <AppLayout>
      <PageHeader title={PROJECT_ANALYSIS_PAGE_TITLE} />
      <div className="p-6 max-w-2xl space-y-3">
        <Alert
          type="error"
          title="Could not load project mix stats"
          message={`${message} If the file is missing, run npm run generate-project-mix-stats.`}
          closeable={false}
        />
        <Button onClick={onRetry}>Retry</Button>
      </div>
    </AppLayout>
  )
}
